export function squaresSlider() {
    const $window = $(window);
    const $slider = $(".js-squares-slider");
    const mobileWidth = 768;

    const slickParams = {
        arrows: false,
        autoplay: true,
        swipe: true,
        infinite: false,
        speed: 500,
        autoplaySpeed: 5000,
        mobileFirst: true,
        responsive: [{
            breakpoint: 319,
            settings: {
                centerMode: true,
                slidesToShow: 1.1,
                slidesToScroll: 1.1,
                centerPadding: "20px"
            }
        }],
    };

    const slickInit = (slickParams, mobileWidth) => {
        const slickInitialized = $slider.hasClass("slick-initialized");
        const mobile = $window.outerWidth() < mobileWidth;

        if (mobile) {
            if (!slickInitialized) {
                [...$slider].map(slider => {
                    $(slider).slick(slickParams);
                });
            }
        } else {
            if (slickInitialized) {
                $slider.slick("unslick");
            }
        }
    };

    slickInit(slickParams, mobileWidth);
    window.addEventListener("resize", () => {
        setTimeout(() => {
            slickInit(slickParams, mobileWidth);
        }, 200);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/nk-slider.js